/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { WebhookDto } from '../models/webhook-dto';


/**
 * Fonctions de gestion des webhooks
 */
@Injectable({
  providedIn: 'root',
})
export class WebhooksService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation webhookGetList
   */
  static readonly WebhookGetListPath = '/api/webhooks/list';

  /**
   * Renvoie la liste des webhooks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhookGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhookGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<WebhookDto>>> {

    const rb = new RequestBuilder(this.rootUrl, WebhooksService.WebhookGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WebhookDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des webhooks.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `webhookGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhookGetList(params?: {
  }): Observable<Array<WebhookDto>> {

    return this.webhookGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<WebhookDto>>) => r.body as Array<WebhookDto>)
    );
  }

  /**
   * Path part for operation webhookLoadList
   */
  static readonly WebhookLoadListPath = '/api/webhooks/load-list';

  /**
   * Renvoie la liste des webhooks (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhookLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  webhookLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, WebhooksService.WebhookLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des webhooks (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `webhookLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  webhookLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.webhookLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation webhookGet
   */
  static readonly WebhookGetPath = '/api/webhooks/{id}';

  /**
   * Renvoie le Webhook spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhookGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhookGet$Response(params: {

    /**
     * Identifiant du Webhook
     */
    id: number;
  }): Observable<StrictHttpResponse<WebhookDto>> {

    const rb = new RequestBuilder(this.rootUrl, WebhooksService.WebhookGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WebhookDto>;
      })
    );
  }

  /**
   * Renvoie le Webhook spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `webhookGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhookGet(params: {

    /**
     * Identifiant du Webhook
     */
    id: number;
  }): Observable<WebhookDto> {

    return this.webhookGet$Response(params).pipe(
      map((r: StrictHttpResponse<WebhookDto>) => r.body as WebhookDto)
    );
  }

  /**
   * Path part for operation webhookPut
   */
  static readonly WebhookPutPath = '/api/webhooks/{id}';

  /**
   * Met à jour le Webhook spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhookPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  webhookPut$Response(params: {

    /**
     * Identifiant du Webhook à mettre à jour
     */
    id: number;

    /**
     * Webhook
     */
    body: WebhookDto
  }): Observable<StrictHttpResponse<WebhookDto>> {

    const rb = new RequestBuilder(this.rootUrl, WebhooksService.WebhookPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WebhookDto>;
      })
    );
  }

  /**
   * Met à jour le Webhook spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `webhookPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  webhookPut(params: {

    /**
     * Identifiant du Webhook à mettre à jour
     */
    id: number;

    /**
     * Webhook
     */
    body: WebhookDto
  }): Observable<WebhookDto> {

    return this.webhookPut$Response(params).pipe(
      map((r: StrictHttpResponse<WebhookDto>) => r.body as WebhookDto)
    );
  }

  /**
   * Path part for operation webhookDelete
   */
  static readonly WebhookDeletePath = '/api/webhooks/{id}';

  /**
   * Supprime le Webhook spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhookDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhookDelete$Response(params: {

    /**
     * Identifiant du Webhook à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, WebhooksService.WebhookDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le Webhook spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `webhookDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhookDelete(params: {

    /**
     * Identifiant du Webhook à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.webhookDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation webhookPost
   */
  static readonly WebhookPostPath = '/api/webhooks';

  /**
   * Crée le Webhook spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhookPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  webhookPost$Response(params: {

    /**
     * Webhook
     */
    body: WebhookDto
  }): Observable<StrictHttpResponse<WebhookDto>> {

    const rb = new RequestBuilder(this.rootUrl, WebhooksService.WebhookPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WebhookDto>;
      })
    );
  }

  /**
   * Crée le Webhook spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `webhookPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  webhookPost(params: {

    /**
     * Webhook
     */
    body: WebhookDto
  }): Observable<WebhookDto> {

    return this.webhookPost$Response(params).pipe(
      map((r: StrictHttpResponse<WebhookDto>) => r.body as WebhookDto)
    );
  }

}
